import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { captureException } from '@sentry/react';
import { Middleware } from 'app/services/middleware';
import { fileAccessService } from 'app/services/fileAccess.service';
import { graphqlOperation } from 'aws-amplify';
import { getUser } from 'graphql/queries';

export const getProfile = createAsyncThunk('profileApp/profile/getProfile', async (userId) => {
  const { graphqlRequest } = Middleware;
  return graphqlRequest(graphqlOperation(getUser, { id: userId }))
    .then(async (res) => {
      const user = res.data.getUser;
      if (user.picture) {
        user.picture = await fileAccessService.getDownloadUrl(user.picture);
      }

      return user;
    })
    .catch((error) => {
      captureException(error);
      // eslint-disable-next-line no-console
      console.log(error);
    });
});

const profileSlice = createSlice({
  name: 'profileApp/profile',
  initialState: {},
  reducers: {
    resetProfileSlice: () => ({}),
  },
  extraReducers: {
    [getProfile.fulfilled]: (state, action) => action.payload,
  },
});
export const { resetProfileSlice } = profileSlice.actions;

export default profileSlice.reducer;
